module.exports = __webpack_public_path__ + "img/wrinkles.680c14be.png";